import React, { useEffect, useState } from "react";
import 'spiketip-tooltip/spiketip.min.css'
import { Link } from "react-router-dom";
import UserService from "../../services/UserService.js";
import AuthService from "../../services/AuthService.js";
import Select, { components } from "react-select";
import axios from "axios";
import { useDispatch } from "react-redux";
import getNotification from "../../Redux/Action/action.js";
import Plot from "react-plotly.js";
import Loader from "react-js-loader";
import FooterPages from '../Footer/FooterPages.jsx'
import Chart from "react-apexcharts";
import Navbar3 from "../Navbars/Navbar3.jsx";
import SubNavbar from "../Navbars/SubNavbar.jsx";
import LoaderCustom from "../LoaderCustom.jsx";

import StackBarChart from "./StackBarChart.jsx";

import '../Brand Analysis/brand.css'
import ExceptionVariables from '../JSON Files/ExceptionVariables.json'
import LineBarChartBrandAnalysisAtta from "./LineBarChartBrandAnalysisAtta.jsx";
import StackBarChartAtta from "./StackBarChartAtta.jsx";
const { REACT_APP_REDIRECT_URI } = process.env;
const { REACT_APP_UPLOAD_DATA } = process.env;
// const { REACT_APP_UPLOAD_DATA } = process.env;

function BrandAnalysisAtta() {
  const [variantoptions, setvariantoptions] = useState([]);
  const [selectedvariant, setselectedvariant] = useState("");
  const [grammageoptions,setgrammageoptions]=useState([])
  const [selectedgrammage,setselectedgrammage]=useState("")
  const selectAllOption = { label: "Select All", value: "selectAll" };
  const [modifybtn, setmodifybtn] = useState(false)
  const [options, setoptions] = useState({})
  const [salesdata, setsalesdata] = useState([])
  const [displaynames, setdisplaynames] = useState({});
  const [currentScreen, setcurrentScreen] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [brandoptions, setbrandoptions] = useState([]);
  const [marketoptions, setmarketoptions] = useState([]);
  const [market, setmarket] = useState([]);
  const [loader, setloader] = useState(false);
  const [resultscreen, setresultscreen] = useState(false);
  const [selectedbrand, setselectedbrand] = useState("ATTA");
  const [variableslist, setvariableslist] = useState([]);
  const [variable, setvariable] = useState([]);
  const [selectedvariable, setselectedvariable] = useState([]);
  const [plotdataweekly, setplotdataweekly] = useState({});
  const [plotdatamonthly, setplotdatamonthly] = useState({});
  const [statisticsdata1, setstatisticsdata1] = useState([]);
  const [corelationdata, setcorelationdata] = useState([]);
  const dispatch = useDispatch();
  const [reportName, setreportName] = useState("");
  const [subvariablesoptions, setsubvariablesoptions] = useState([])
  const [variablesoptions, setvariablesoptions] = useState([])
  const [uniquetypes, setuniquetypes] = useState([])
  const [selectedsubvariables1, setselectedsubvariables1] = useState([])
  const [selectedsubvariables2, setselectedsubvariables2] = useState([])
  const [selectedsubvariables3, setselectedsubvariables3] = useState([])
 useEffect(() => {
   
     handlefetchmarket();
     handledatesfetch();
   
   }, []);
  
   useEffect(() => {
     handlefetchvariant()
   }, [market])
   useEffect(() => {
     handlefetchkeys()
   }, [selectedvariant])
   useEffect(() => {
     handlefetchvariables()
   }, [selectedgrammage])
   const handlefetchmarket = async () => {
    if (UserService.isLoggedIn()) {
      try {
        const FormData = require("form-data");
        const sendData = new FormData();
        sendData.append("brand", selectedbrand)
        const config = {
          method: "post",
          url: `${REACT_APP_UPLOAD_DATA}/app/atta_get_markets`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: sendData,
        };
        const getResponse = await axios(config);
        // console.log(getResponse)
        if (getResponse.data !== "Invalid User!") {
          setmarketoptions(
            [
         // Add Select All option
         ...getResponse.data.markets?.map((it) => ({
           value: it.final_market,
           label: it.final_market,
         })),
       ]
           );
        }
      } catch (err) {
      
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/attabrandanalysis`,
        });
      }, 1000);
    }
  };
  const handlefetchvariables = async () => {
    if (UserService.isLoggedIn()) {
      try {
        const FormData = require("form-data");
        const sendData = new FormData();
       
        const requestData={
          start_date:`${startDate} 00:00:00.000`,
          end_date:`${endDate} 00:00:00.000`,
          market:market[0],
          variant:selectedvariant,
          key:selectedgrammage
        
         
        }
      
        const config = {
          method: "post",
          url: `${REACT_APP_UPLOAD_DATA}/app/b_a/atta_get_variables`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: requestData,
        };
         const getResponse = await axios(config);
        // console.log(getResponse)
        if (getResponse.status===200) {
          let arr = getResponse?.data?.filter(
            (item) => !ExceptionVariables?.zeroOrOneVariables?.includes(item.attribute_name)
          );
          arr.sort((a, b) => a.attribute_name.localeCompare(b.attribute_name));
        arr.push(...ExceptionVariables?.additionstogetvariablesapiatta)
       
        console.log(arr)

        setvariablesoptions(arr)
        setuniquetypes(Array.from(new Set(arr?.map((item => {
          return item.type
        })))))
        }
      } catch (err) {
      
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/attamarketanalysis`,
        });
      }, 1000);
    }
  };
  const handlefetchvariant = async () => {
    if (UserService.isLoggedIn()) {
      try {
        const FormData = require("form-data");
        const sendData = new FormData();
        sendData.append("market", market)
        const requestData={
          "market":market[0]
        }
        const config = {
          method: "post",
          url: `${REACT_APP_UPLOAD_DATA}/app/b_a/atta_get_variant`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: requestData,
        };
        const getResponse = await axios(config);
        // console.log(getResponse)
        if (getResponse.data !== "Invalid User!") {
        setvariantoptions(getResponse.data?.map((it)=>{
          return {label:it,value:it}
        }))
        }
      } catch (err) {
      
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/attamarketanalysis`,
        });
      }, 1000);
    }
  };
  const handlefetchkeys = async () => {
    if (UserService.isLoggedIn()) {
      try {
        const FormData = require("form-data");
        const sendData = new FormData();
        sendData.append("brand", selectedbrand)
const requestData={
  start_date:`${startDate} 00:00:00.000`,
  end_date:`${endDate} 00:00:00.000`,
  market:market[0],
variant:selectedvariant
}


        const config = {
          method: "post",
          url: `${REACT_APP_UPLOAD_DATA}/app/b_a/atta_get_key`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: requestData,
        };
        const getResponse = await axios(config);
        // console.log(getResponse)
        if (getResponse.data !== "Invalid User!") {
        setgrammageoptions(getResponse.data?.map((it)=>{
          return {label:it,value:it}
        }))
        }
      } catch (err) {
      
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/attamarketanalysis`,
        });
      }, 1000);
    }
  };
  const reverseDate = (dateString) => {
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
  }

  const scrollToSection = (sectionname) => {
    // Replace 'section2' with the id of the section you want to scroll to

    if (document.getElementById(sectionname)) {
      document
        .getElementById(sectionname)
        .scrollIntoView({ behavior: "smooth" });
    } else {
      dispatch(
        getNotification({
          message: "Please proceed with first analysis ",
          type: "Default",
        })
      );
    }
  };

  const handledatesfetch = async () => {
    if (UserService.isLoggedIn()) {
      try {
      const FormData = require("form-data");
      const sendData = new FormData();
      const config = {
          method: "get",
          url: `${REACT_APP_UPLOAD_DATA}/app/b_a/atta_get_date`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: sendData,
        };
        const getResponse = await axios(config);
        if (getResponse.data !== "Invalid User!") {
          setStartDate(getResponse.data.start_date?.split("T")[0]);
          setEndDate(getResponse.data.end_date?.split("T")[0]);
                
        
                }
      } catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/brandanalysis`,
        });
      }, 1000);
    }
  };
  

  const handlecheckboxesselection = (e, item) => {
    if (e.target.checked) {
      if (e.target.value === ExceptionVariables.additionstogetvariablesapiatta[0].attribute_name || e.target.value === ExceptionVariables.additionstogetvariablesapiatta[1].attribute_name
        || e.target.value === ExceptionVariables.additionstogetvariablesapiatta[2].attribute_name
        //  || e.target.value === ExceptionVariables.additionstogetvariablesapiatta[3].attribute_name ||
        // e.target.value === ExceptionVariables.additionstogetvariablesapiatta[4].attribute_name ||
        // e.target.value === ExceptionVariables.additionstogetvariablesapiatta[5].attribute_name
      ) {
        selectedvariable?.map((variable) => {
          document.getElementById(variable).checked = false
        })
        const arr = []
        arr.push(item.attribute_name)
        setselectedvariable(arr);
      }
      else {
        if (selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapiatta[0].attribute_name) || selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapiatta[1].attribute_name) || 
          selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapiatta[2].attribute_name)
          // || selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapiatta[3].attribute_name) ||
          //     selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapiatta[4].attribute_name) ||
          //     selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapiatta[5].attribute_name)
        ) {
          e.target.checked = false;
          dispatch(getNotification({ message: "Aggregated variable already selected!!", type: "danger" }))
        }
        else {
          if (false) {
            dispatch(getNotification({ message: "Only 6 variable allowed at one time!!", type: "danger" }))
            e.target.checked = false;
          }
          else {
            const arr = [...selectedvariable]
            arr.push(item.attribute_name)
            setselectedvariable(arr);
          }
        }
      }

    }

    else {
      let arr = [...selectedvariable]
      arr = arr.filter(variable => variable !== item.attribute_name);
      setselectedvariable(arr);
    }


  };
  const handlebrandanalysis = async () => {
    if (UserService.isLoggedIn()) {
      if (selectedbrand && startDate && endDate && market?.length > 0 && selectedvariable?.length > 0) {
        try {
          let arr1 = []
          let arr2=[]
          console.log(selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapiatta[0].attribute_name))
          if (selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapiatta[0].attribute_name)) {
            arr1 = variablesoptions?.filter((it)=>
              it.attribute_name.startsWith("Aashirvaad")
             
            )?.map((it)=>it.attribute_name)
          
          }
          else if (selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapiatta[1].attribute_name)) {
            arr1 = ExceptionVariables.tp_Aggregated_Variables_inr
          }
          else if (selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapiatta[2].attribute_name)) {
            arr1 = ExceptionVariables.cp_Aggregated_Variables_inr_atta
          }
          // else if (selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapiatta[3].attribute_name) 
          //   || selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapiatta[4].attribute_name) 
          // || selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapiatta[5].attribute_name)) {
          //   selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapiatta[3].attribute_name) && arr2.push(ExceptionVariables.additionstogetvariablesapiatta[3].attribute_name)
          //   selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapiatta[4].attribute_name) && arr2.push(ExceptionVariables.additionstogetvariablesapiatta[4].attribute_name)
          //   selectedvariable?.includes(ExceptionVariables.additionstogetvariablesapiatta[5].attribute_name) && arr2.push(ExceptionVariables.additionstogetvariablesapiatta[5].attribute_name)
          //   arr1 = selectedvariable
          // }
        
          else {
            arr1 = selectedvariable
          }
          
//           arr1 = arr1.filter(it => !arr2.includes(it));
if(arr1.length===0){
  dispatch(getNotification({message:"There are no variables present in selected category!",
    type:"danger"
  }))
  return
}
          setloader(true);
          const requestData = 
          {
            start_date:`${startDate} 00:00:00.000`,
            end_date:`${endDate} 00:00:00.000`,
            "market": market[0],
            "variant": selectedvariant,
            "key": selectedgrammage,
            "variable": arr1
          }
         
       
          const config1 = {
            method: "post",
            url: `${REACT_APP_UPLOAD_DATA}/app/b_a/get_brand_analysis`,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            data: requestData,
          };
          // const config2 = {
          //   method: "post",
          //   url: `${REACT_APP_UPLOAD_DATA}/app/monthly_brandanalysis`,
          //   headers: {
          //     Accept: "application/json",
          //     "Content-Type": "application/json",
          //   },
          //   data: requestData,
          // };
          const getResponse1 = await axios(config1);
         // const getResponse2 = await axios(config2);

          if (getResponse1.status === 200 && getResponse1.data?.length>0) {

            if (getResponse1.data[0] !== "Invalid User!") {
 let arr1=[...getResponse1.data]
//  arr1=arr1.map((it)=>{
//   return {...it,
//   variables:[...it.variables,...it.variable_types]}
//  })

//  let arr2=[...getResponse2.data?.market_data]
//  arr2=arr2.map((it)=>{
//   return {...it,
//   variables:[...it.variables,...it.variable_types]}
//  })

              //setplotdataweekly(arr1)
              setplotdatamonthly(arr1)
              
             
              setresultscreen(true);
              setdisplaynames({
                ...displaynames,
                startDate: startDate,
                endDate: endDate,
                selectedbrand: selectedbrand,
                variable: selectedvariable,
                market: market,
                variant:selectedvariant,
                grammage:selectedgrammage

              })
            }
            else if (getResponse1.data[0] === "Invalid User!") {
              UserService.doLogin({
                redirectUri: `${REACT_APP_REDIRECT_URI}/brandanalysis`,
              });
            }
          }
        } catch (err) {
          //handleMouseEnter();
          setresultscreen(false)
          setmodifybtn(false)
          console.log("Server Error", err);
          if (err.response && err.response.status === 500) {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 400) {
            dispatch(
              getNotification({
                message: "Input is not in prescribed format",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 422) {
            dispatch(
              getNotification({
                message: "Input is not in prescribed format",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 404) {
            dispatch(
              getNotification({
                message: "Page not Found",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 401) {
            dispatch(
              getNotification({
                message: "Session expired! Please log in again",
                type: "default",
              })
            );
          } else {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          }
        }
      } else {
        dispatch(
          getNotification({
            message: "Please fill all entries",
            type: "default",
          })
        );
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/brandanalysis`,
        });
      }, 1000);
    }
    setloader(false);
  };

  const fetchstatisticsdata = async () => {
    if (UserService.isLoggedIn()) {
      try {
        const requestData = {
          // jwttoken: UserService.getToken(),
          start_date: startDate,
          end_date: endDate,
          variables: [variable],
          brand: selectedbrand,
        };

        const config = {
          method: "post",
          url: `${REACT_APP_UPLOAD_DATA}/app/statistics`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
          },
          data: requestData,
        };
        const getResponse = await axios(config);

        // setplot1list(Array.from(getResponse.data));
        if (getResponse.status === 200) {
          if (getResponse.data === "No Records Found." || getResponse.data === "42883: function round(real, integer) does not exist\n\nPOSITION: 25") {
            dispatch(
              getNotification({
                message: "There are no statistics record",
                type: "default",
              })
            );
          } else {

            setstatisticsdata1(getResponse.data);
          }

        }
      } catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/brandanalysis`,
        });
      }, 1000);
    }
  };
  const handlesavereport = async () => {
    if (UserService.isLoggedIn()) {
      if (reportName && variable && selectedbrand && startDate && endDate) {
        try {
          setloader(true);

          const requestData = {
            report_name: reportName,
            start_date: displaynames.startDate,
            end_date: displaynames.endDate,
            brand: displaynames.selectedbrand,
            market: displaynames.market[0],
            variables: displaynames.variable,
            user_created_by: UserService.getUsername(),
            created_on: new Date().toISOString().split("T")[0],
            screen: "B_A"
          };
          const config = {
            method: "post",
            url: `${REACT_APP_UPLOAD_DATA}/app/saveBAReport`,
            headers: {
              Accept: "text/plain",
              "Content-Type": "application/json",
            },
            data: requestData,
          };
          const getResponse = await axios(config);

          // setplot1list(Array.from(getResponse.data));
          if (getResponse.status === 200) {
            document.getElementById("closemodal").click()
            dispatch(
              getNotification({
                message: `${getResponse?.data}`,
                type: "success",
              })
            );
          }
        } catch (err) {
          console.log("Server Error", err);
          if (err.response && err.response.status === 500) {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 400) {
            document.getElementById("closemodal").click()
            dispatch(
              getNotification({
                message: err.response.data,
                type: "danger",
              })
            );
          } else if (err.response && err.response.status === 422) {
            dispatch(
              getNotification({
                message: "Input is not in prescribed format",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 404) {
            dispatch(
              getNotification({
                message: "Page not Found",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 401) {
            dispatch(
              getNotification({
                message: "Session expired! Please log in again",
                type: "default",
              })
            );
          } else {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          }
        }
      } else {
        dispatch(
          getNotification({
            message: "Please fill all entries",
            type: "default",
          })
        );
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/brandanalysis`,
        });
      }, 1000);
    }
    setloader(false);
  };
  const fetchcorelationdata = async () => {
    if (UserService.isLoggedIn()) {
      try {
        const requestData = {
          // jwttoken: UserService.getToken(),
          start_date: startDate,
          end_date: endDate,
          variables: selectedvariable,
          brand: selectedbrand,
        };
        const config = {
          method: "post",
          url: `${REACT_APP_UPLOAD_DATA}/app/correlation`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
          },
          data: requestData,
        };
        const getResponse = await axios(config);
        // setplot1list(Array.from(getResponse.data));
        if (getResponse.status === 200) {
          if (getResponse.data === "No Records Found.") {
            dispatch(
              getNotification({
                message: "There are not statistics record",
                type: "default",
              })
            );
          } else {
            setcorelationdata(getResponse.data.matrix);
          }
        }
      } catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/brandanalysis`,
        });
      }, 1000);
    }
  };
  function matchHeights() {
    // Get the elements
    var element1 = document.getElementById('sidenav');
    var element2 = document.getElementById('mainscreen');

    var maxHeight = Math.max(element1.offsetHeight, element2.offsetHeight);


    // Set the height of both elements

    element1.style.height = maxHeight + 25 + 'px';
    element2.style.height = maxHeight + 'px';
    // console.log(element1.style.height,element2.style.height)
  }
  return (
    <>
      {/* save report modal */}

      <div
        class="modal "
        id="exampleModal1"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div className="modal-content" >
            <div class="modal-header" style={{ backgroundColor: "#f2f2f2" }}>
              <h6 class="modal-title" id="exampleModalLabel">
                Save Report
              </h6>
              <button
                type="button"
                class="close"
                id="closemodal"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <label>Please enter report Name: </label>
              <input
                type="text"
                id="reportnamebox"
                className="form-control"
                value={reportName}
                onChange={(e) => setreportName(e.target.value)}
              />

              <br />
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary btn-sm"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                onClick={() => {
                  if (reportName === "") {
                    document.getElementById("reportnamebox").focus();
                  } else {
                    handlesavereport();
                  }
                }}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
      <Navbar3 />
      <SubNavbar />


      <div className="bgpages">
        <div className=' mx-5 py-3'>
          <div className='greentheme '>{`Dashboard >> Brand Analysis`}</div>
          <div className='p-2 bg-white greentheme my-3 d-flex justify-content-between' style={{ fontSize: "20px" }}>
            <b className="my-auto">Brand Analysis</b>
            {resultscreen && <div className="">
              {/* <button data-toggle={"modal"}
                data-target="#exampleModal1"
                className="btn btn-dark mx-1 mb-1" >Save Report</button> */}
              <button className="btn btn-danger  mx-1 mb-1" onClick={() => { setmodifybtn(false); setresultscreen(false); setselectedvariable([]); setmarket([]); setselectedbrand("ATTA"); setvariablesoptions([]); }}>Reset</button>

              <button className="btn btn-dark mx-1 mb-1" onClick={() => setmodifybtn(!modifybtn)}>Modify</button>


            </div>}
          </div>
          {modifybtn && <div className="card p-3">
            <div className="col-sm-11 mx-auto">
              <div className="d-flex justify-content-between flex-wrap "  >
                <div className="">
                  <label htmlFor="" >
                    Start Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"

                    className="form-control input-lg"
                    id="StartDate"
                    value={startDate}
                    onChange={(e) => {

                      if (endDate) {
                        if (e.target.value <= endDate) {

                          setStartDate(e.target.value);
                        } else {
                          alert("Entered start date is after end date");
                        }
                      } else {
                        setStartDate(e.target.value);
                      }
                    }}
                    placeholder=" Start Date"
                  />

                </div>

                <div className="  ">
                  <label htmlFor="">
                    End Date<span className="text-danger">*</span>
                  </label>
                  <input

                    type="date"
                    className=" form-control "
                    id="EndDate"
                    placeholder="End Date"
                    value={endDate}
                    onChange={(e) => {
                      if (e.target.value >= startDate) {
                        setEndDate(e.target.value);
                      } else {
                        alert("Please enter End date after start date");
                      }
                    }}
                  />

                </div>
               
                <div className="">
                  <label>Market:<span className="text-danger">*</span></label>
                  <Select
                    placeholder="Select Market"
                    options={marketoptions}

                    // value={market ? { label: market, value: market } : null}
                    // onChange={(value) => {
                    // setmarket(value.value);
                    // }}
                    value={market?.length > 0 ? market.map((it) => { return { label: it, value: it } }) : null}
                    onChange={(value) => {
                      setmarket([value.value])
                      let arr = [...selectedvariable]

                      arr.map((it) => {
                        const element = document.getElementById(it);
                        if (element) {
                          element.checked = false;
                        }
                      })
                      setvariablesoptions([])
                      setselectedvariable([])
                      setvariantoptions([])
                      setgrammageoptions([])
setselectedvariant("")
setselectedgrammage("")
setresultscreen(false)
setmodifybtn(false)
                    }}
                  />










                </div>

                {/* <div >
  Scope:
  <select className="my-2 form-select" value={selectedscope} onChange={(e)=>setselectedscope(e.target.value)}>
    <option>Select</option>
    <option>0</option>
    <option>1</option>
  </select>
</div> */}

                <div>
                  <button
                    id="subm"
                    className="btn btn-dark  mt-4"
                    onClick={() => {
                      //scrollToSection("heightmainscreen");
                      handlebrandanalysis();
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>

              {market?.length > 0 &&
                <div className="my-2">
                  <div className="d-flex"><div className="col-sm mx-2">
                            <label>Prod Hierarchy:<span className="text-danger">*</span></label>
                            <Select
                              placeholder="Select Prod Hierarchy"
                              options={variantoptions}
                              
                              // value={market ? { label: market, value: market } : null}
                              // onChange={(value) => {
                              // setmarket(value.value);
                              // }}
                              value={selectedvariant ? { label:selectedvariant, value: selectedvariant } : null}
                              onChange={(value) => {
                            
                            setselectedvariant(value.value);
                                setselectedgrammage("")
                            setselectedvariable("")
                            setgrammageoptions([])
                              }}
                            />





                          </div>
                          <div className="col-sm  mx-2">
                            <label>Grammage Wise Variant:<span className="text-danger">*</span></label>
                            <Select
                              placeholder="Select Grammage"
                              options={grammageoptions}
                              
                              // value={market ? { label: market, value: market } : null}
                              // onChange={(value) => {
                              // setmarket(value.value);
                              // }}
                              value={selectedgrammage ? { label:selectedgrammage, value: selectedgrammage } : null}
                              onChange={(value) => {
                               
                                setselectedgrammage(value.value);
                                
                            setselectedvariable([])
                              }}
                            />
                          </div></div> 
                          {selectedgrammage &&    <div>Select Marketing Inputs:</div>}
                 {selectedgrammage &&
                  <div class="accordion col-sm-12 my-2" id="accordionExample2">
                  {uniquetypes?.map((item, index) => {
                    return <div class="accordion-item">
                      <h2 class="accordion-header" id={`heading${index}`}>
                        <button class="accordion-button accordion-button2 collapsed" type="button"
                          data-toggle="collapse" data-target={`#collapse${index}`} aria-expanded="false" aria-controls={`collapse${index}`}
                        >
                          <b>{item ? item : "All"}</b>
                        </button>
                      </h2>
                      <div id={`collapse${index}`} class="collapse" aria-labelledby={`heading${index}`}>
                        <div class="accordion-body">
                          <div  className="variables-container">
                            {variablesoptions?.map((it) => {
                              return it?.type === item &&
                                <div className="variable-item">
                              <input className="mx-2" type="checkbox" id={it.attribute_name} value={it.attribute_name}
                               checked={selectedvariable?.includes(it.attribute_name)}
                                 onChange={(e) => {
                                      handlecheckboxesselection(e, it)

                                    }} />    <span >{it.attribute_name}</span>
                                  

                                </div>
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  })}


                </div>}
                </div>}

            </div>
          </div>}
          <div className=" my-3 ">
            <div className=" " >
              {loader ? (
                <div
                  className="row d-flex  justify-content-center align-items-center "
                  style={{ height: "75vh" }}
                >
                  <LoaderCustom text="Processing..." />

                  {/* <Loader
                    type="box-rectangular"
                    bgColor={"#0A4742"}
                    title={"Processing plots..."}
                    color={"#0A4742"}
                    size={75}
                  /> */}
                </div>
              ) : resultscreen ?
                <div>
                  {resultscreen && displaynames.selectedbrand?.length > 0
                    // && displaynames.variableslist?.length>0
                    &&
                    <div className=" bg-white p-2"  >
                      <span className=" greentheme" style={{ fontSize: "17px" }}><b>User Selections</b>

                      </span>
                      <div className="d-flex justify-content-between my-2">
                        <div className="mx-2">
                          <label>Start Date:{" "}</label>
                          <label className="mx-1">{displaynames.startDate}</label>
                        </div>
                        <div className="mx-2">
                          <label>End Date:{" "}</label>
                          <label className="mx-1">{displaynames.endDate}</label>
                        </div>
                        
                        <div className="mx-2">
                          <label>Market:{" "}</label>
                          <label className="mx-1">


                           

                              {displaynames?.market}
                      
                          </label>
                        </div>
                        <div className="mx-2">
                          <label>Variant:{" "}</label>
                          <label className="mx-1">


                           

                              {displaynames?.variant}
                      
                          </label>
                        </div>
                      </div>

                      <div className="row">
                      <div className="col-sm-2">
                          <label>Grammage:{" "}</label>
                          <label className="mx-1 inputs">{displaynames.grammage}</label>
                        </div>
                      
                        <div className="col-sm-10">
                          <span>Variables:{" "}</span>
                          <span className="mx-1  " style={{ width: '100%' }}>
  {displaynames.variable?.length > 1
    ? <div className="inputs">{displaynames.variable.map((brand, index) =>
        `${brand}${index !== displaynames.variable.length - 1 ? ', ' : ''}`
      )}</div>
    : <span className="inputs">{displaynames.variable.map((brand) => `${brand}`)}</span>}
</span>
                        </div>

                      </div>

                    </div>}



                
                  {
                    (
                      displaynames?.variable?.includes(ExceptionVariables.additionstogetvariablesapiatta[0].attribute_name) ||
                      displaynames?.variable?.includes(ExceptionVariables.additionstogetvariablesapiatta[1].attribute_name) ||
                      displaynames?.variable?.includes(ExceptionVariables.additionstogetvariablesapiatta[2].attribute_name)
                    ) ?(
                      <StackBarChartAtta
                        plotdataweekly={plotdataweekly}
                        plotdatamonthly={plotdatamonthly}
                        displaynames={displaynames}
                      />
                    ):
                    <LineBarChartBrandAnalysisAtta plotdataweekly={plotdataweekly} plotdatamonthly={plotdatamonthly} displaynames={displaynames} />
                  }

                 



                </div>
                :
                <>
                  <div className="card p-3 ">
                  <div className="my-2">
                            Brand:                 <span>ATTA</span>

                        </div>
                    <div className="mx-4">
                      <div className=" ">
                        {true ?

                          <div className="d-flex justify-content-between flex-wrap">
                            <div className="my-2">
                              <label htmlFor="" >
                                Start Date<span className="text-danger">*</span>
                              </label>
                              <input
                                type="date"
                                disabled={resultscreen}
                                className="form-control input-lg p-2"
                                id="StartDate"
                                value={startDate}
                                onChange={(e) => {
                                  if (endDate) {
                                    if (e.target.value <= endDate) {
                                      setStartDate(e.target.value);
                                    } else {
                                      alert("Entered start date is after end date");
                                    }
                                  } else {
                                    setStartDate(e.target.value);
                                  }
                                }}
                                placeholder=" Start Date"
                              />

                            </div>

                            <div className=" my-2 ">
                              <label htmlFor="">
                                End Date<span className="text-danger">*</span>
                              </label>
                              <input
                                disabled={resultscreen}
                                type="date"
                                className=" form-control p-2"
                                id="EndDate"
                                placeholder="End Date"
                                value={endDate}
                                onChange={(e) => {
                                  if (e.target.value >= startDate) {
                                    setEndDate(e.target.value);
                                  } else {
                                    alert("Please enter End date after start date");
                                  }
                                }}
                              />

                            </div>
                           
                            <div className="my-2">
                              <label>Market:<span className="text-danger">*</span></label>
                              <Select
                                placeholder="Select Market"
                                options={marketoptions}

                                // value={market ? { label: market, value: market } : null}
                                // onChange={(value) => {
                                // setmarket(value.value);
                                // }}
                                value={market?.length > 0 ? market.map((it) => { return { label: it, value: it } }) : null}
                                onChange={(value) => {
                                  setmarket([value.value])
                                  let arr = [...selectedvariable]

                                  arr.map((it) => {
                                    const element = document.getElementById(it);
                                    if (element) {
                                      element.checked = false;
                                    }
                                  })
                                  setvariablesoptions([])
                                  setselectedvariable([])
                                  setvariantoptions([])
                                  setgrammageoptions([])
            setselectedvariant("")
            setselectedgrammage("")

                                }}
                              />
                            </div>




                          </div>
                          : "Loading..."}
                      </div>
                      <div className="">
                        {true

                          && <>

                            <div className="row my-2">
                            <div className="">
                      {variantoptions?.length > 0

                        && <>
                        
                        <div className="row my-2">
                        <div className="col-sm mx-2">
                            <label>Prod Hierarchy:<span className="text-danger">*</span></label>
                            <Select
                              placeholder="Select Prod Hierarchy"
                              options={variantoptions}
                              
                              // value={market ? { label: market, value: market } : null}
                              // onChange={(value) => {
                              // setmarket(value.value);
                              // }}
                              value={selectedvariant ? { label:selectedvariant, value: selectedvariant } : null}
                              onChange={(value) => {
                              console.log(value)
                            setselectedvariant(value.value);
                                setselectedgrammage("")
                            setselectedvariable([])
                            setgrammageoptions([])
                              }}
                            />





                          </div>
                          <div className="col-sm  mx-2">
                            <label>Grammage Wise Variant:<span className="text-danger">*</span></label>
                            <Select
                              placeholder="Select Grammage"
                              options={grammageoptions}
                              
                              // value={market ? { label: market, value: market } : null}
                              // onChange={(value) => {
                              // setmarket(value.value);
                              // }}
                              value={selectedgrammage ? { label:selectedgrammage, value: selectedgrammage } : null}
                              onChange={(value) => {
                               
                                setselectedgrammage(value.value);
                                
                            setselectedvariable([])
                              }}
                            />





                          </div>
                          
                        </div>
                        

                           </>}


                    </div>
                            {variablesoptions?.length > 0 && selectedgrammage &&                  <div>Select Marketing Inputs:</div>}
                         
                            
                              {variablesoptions?.length > 0 && selectedgrammage &&
                                <div className="my-2">



                                  <div class="accordion col-sm-12 my-2" id="accordionExample2">
                                    {uniquetypes?.map((item, index) => {
                                      return <div class="accordion-item">
                                        <h2 class="accordion-header" id={`heading${index}`}>
                                          <button class="accordion-button accordion-button2 collapsed" type="button"
                                            data-toggle="collapse" data-target={`#collapse${index}`} aria-expanded="false" aria-controls={`collapse${index}`}
                                          >
                                            <b>{item ? item : "All"}</b>
                                          </button>
                                        </h2>
                                        <div id={`collapse${index}`} class="collapse" aria-labelledby={`heading${index}`}>
                                          <div class="accordion-body">
                                            <div  className="variables-container">
                                              {variablesoptions?.map((it) => {
                                                return it?.type === item &&
                                                  <div className="variable-item ">
                                                <input className="mx-2" type="checkbox" id={it.attribute_name} value={it.attribute_name} checked={selectedvariable.length>0 && selectedvariable?.includes(it.attribute_name)}
                                                      onChange={(e) => {
                                                        handlecheckboxesselection(e, it)

                                                      }} />  {it.attribute_name}
                                                    

                                                  </div>
                                              })}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    })}


                                  </div>


                                </div>}
                            </div>
                            <div class="submitfrmtbtn mb-2" type="button" onClick={() => {

                              handlebrandanalysis();
                            }}>
                              <span>Submit <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon></span></div>

                          </>}


                      </div>
                    </div>


                  </div>

                </>
              }

            </div>
          </div>
        </div>
      </div>

      <div className='' >
        <FooterPages />
      </div>








































    </>
  );
}

export default BrandAnalysisAtta;
